import styled from 'styled-components';

export const ContentWrapper = styled.div`
  padding-top: 8px;
  padding-right: 16px;
`;
